<div class="fixed inset-0 z-150 flex items-center justify-center p-4" (click)="close()">
  <div class="modal-content w-full max-w-2xl rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">Textbaustein einfügen</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Content -->
    <div class="flex h-96">
      <!-- Left Side - Text Block List -->
      <div class="w-1/2 border-r border-white/10">
        <div class="h-12 flex items-center px-4 border-b border-white/10">
          <div class="relative w-48">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span class="material-icons text-xs text-text-muted">search</span>
            </div>
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
              placeholder="Suchen..."
              class="w-full pl-8 pr-8 py-1.5 text-xs rounded-lg bg-white/8 border border-white/12 text-text-primary placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all"
            />
            @if (searchTerm) {
              <button
                type="button"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-text-muted hover:text-text-primary transition-colors"
                (click)="clearSearch()"
              >
                <span class="material-icons text-sm">close</span>
              </button>
            }
          </div>
        </div>
        <div class="overflow-y-auto h-full">
          @if (isLoading) {
            <div class="flex items-center justify-center h-32">
              <div class="text-text-muted">Lade Textbausteine...</div>
            </div>
          } @else if (textBlocks.length === 0) {
            <div class="flex items-center justify-center h-32">
              <div class="text-text-muted">Keine Textbausteine verfügbar</div>
            </div>
          } @else {
            <ul class="p-2 h-80 overflow-y-auto">
              @for (textBlock of textBlocks; track textBlock._id) {
                <li>
                  <button
                    [title]="textBlock.title"
                    type="button"
                    class="w-full cursor-pointer text-left p-3 rounded-lg hover:bg-white/10 transition-all"
                    [ngClass]="selectedTextBlock?._id === textBlock._id ? 'bg-white/10 text-text-primary' : 'text-text-muted'"
                    (click)="selectTextBlock(textBlock)"
                  >
                    <div class="font-medium text-sm">{{ textBlock.title }}</div>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>

      <!-- Right Side - Preview -->
      <div class="w-1/2 flex flex-col">
        <div class="h-12 flex items-center px-4 border-b border-white/10">
          <h3 class="text-sm font-medium text-text-secondary">Vorschau</h3>
        </div>
        <div class="flex-1 p-4 overflow-y-auto">
          @if (selectedTextBlock) {
            <div class="space-y-4">
              <div>
                <h4 class="text-base font-semibold text-text-primary mb-2">{{ selectedTextBlock.title }}</h4>
                <p class="text-sm text-text-secondary leading-relaxed">{{ selectedTextBlock.description }}</p>
              </div>
            </div>
          } @else {
            <div class="flex items-center justify-center h-full">
              <div class="text-center text-text-muted">
                <span class="material-icons text-4xl mb-2 block">text_snippet</span>
                <p class="text-sm">Wählen Sie einen Textbaustein aus der Liste</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-white/10">
      <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
      <button type="button" class="btn-primary px-5 py-2.5 text-sm" [disabled]="!selectedTextBlock" (click)="addTextBlock()">Einfügen</button>
    </div>
  </div>
</div>
